"use strict";

exports.__esModule = true;
exports.createSlotVeloAPIFactory = createSlotVeloAPIFactory;
var _createSdkProxy = require("./createSdkProxy");
function createSlotVeloAPIFactory(controllerConfig) {
  return {
    getSlotAPI(slotId) {
      return (0, _createSdkProxy.createSdkProxy)(controllerConfig.getSlot(slotId));
    }
  };
}
//# sourceMappingURL=slotsPlaceholderVeloAPIFactory.js.map